// extracted by mini-css-extract-plugin
export default {"wrapper":"TableEmptyState_wrapper__UPDa7","icon":"TableEmptyState_icon__ftCHv","title":"TableEmptyState_title__uLSKF","hint":"TableEmptyState_hint__V8x0M"};